module.exports = __webpack_public_path__ + "img/walkman.a11ac4a4.png";